import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from './shared/services/global_variable.service';
import { Location } from '@angular/common';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

    @HostListener('document:contextmenu', ['$event'])
    onRightClick(event: MouseEvent) {
        event.preventDefault()
    }
    pathname: string;
    isHeaderHide: any;
    isHideFooter: any;

    constructor(private router: Router,  private _globalService: GlobalService, private location: Location ) {

        location.onUrlChange(url => {
            this.pathname = url;
            // this.isHeaderHide = this._globalService.hideHeader.includes(this.pathname);
            // this.isHideFooter = this._globalService.hideFooter.includes(this.pathname);

            this.isHeaderHide = RegExp(this._globalService.hideHeader.join('|')).exec(this.pathname);
            this.isHideFooter = RegExp(this._globalService.hideFooter.join('|')).exec(this.pathname);

            // console.log('pathname', this.pathname);
            // console.log('isHeaderHide', this.isHeaderHide, this._globalService.hideHeader);
            // console.log('isHideFooter', this.isHideFooter, this._globalService.hideFooter);


        });
    }


    ngOnInit() {}
}

